import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';

@Model()
export default class Image extends ApplicationRecord {
  static jsonapiType = 'images';
  @Attr() name: string;
  @Attr() description: string;
  @Attr() identifier: string;
  @Attr() regionCode: string;
  @Attr() platform: string;
  @Attr() imagePipelineName: string;
  @Attr() latest: boolean;
  @Attr({ persist: false }) selected: boolean;

  @BelongsTo() facility: Facility;

  constructor(attrs?: Record<string, any>) {
    super(attrs);
    this.selected = false;
  }
}
